import { render, staticRenderFns } from "./ManageCAPermissions.vue?vue&type=template&id=6cbe79b2&"
import script from "./ManageCAPermissions.vue?vue&type=script&lang=js&"
export * from "./ManageCAPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports